import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Club from "../../api/models/Club";
import { Link } from "react-router-dom";
import { DateFormat, formatDate } from "../../utils/datePareser";
import { defaultImgs } from "../../utils/defaultImages";

interface ClubConfirmationPageProps {
  selectedClub: Club | null;
  handleConfirm: () => void;
  handleCancel: () => void;
  makeOfferUrl: string;
  returnTo: string;
  partyDate?: Date | string;
}

const ClubConfirmationPage: React.FC<ClubConfirmationPageProps> = ({
  selectedClub,
  handleConfirm,
  handleCancel,
  makeOfferUrl,
  returnTo,
  partyDate,
}) => {
  const [prompt, setPrompt] = useState<string>("");

  useEffect(() => {
    if (selectedClub) {
      const formattedPartyDate = partyDate
        ? formatDate(new Date(partyDate), false, DateFormat.Long, true)
        : "this date";
      const clubPrompt = `Are you sure ${selectedClub.name} is open on ${formattedPartyDate}?`;

      setPrompt(clubPrompt);
    }
  }, [partyDate, selectedClub]);

  if (!selectedClub) {
    return null;
  }

  return (
    <Modal show={true} onHide={handleCancel} centered>
      <Modal.Body>
        <div className="clubCon">
          <div className="form-check m-3 align-items-center col d-flex">
            <img
              src={selectedClub.img || defaultImgs.ClubImg}
              className="clubImg"
              alt={selectedClub.name}
            />
            <div className="align-content-center col d-flex">
              <label className="yellowTxt col">{selectedClub.name}</label>
            </div>
          </div>
        </div>
        <p className="text-center mt-2 mb-2">{prompt}</p>
      </Modal.Body>
      <Modal.Footer>
        <div className=" yellowTxt container">
          <Link
            to={makeOfferUrl}
            state={{ returnTo, preserveOfferState: true }}
            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
            onClick={handleConfirm}
          >
            Confirm
          </Link>
          <button
            type="button"
            className="link btns btnMO justify-content-center d-flex mt-3 align-content-center  col-12 mt-2 mb-2"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ClubConfirmationPage;
